import customApiFetchBase from '@/shared/utils/customApiFetchBase';
import { createApi } from '@reduxjs/toolkit/query/react';

export const mainEmptySplitApi = createApi({
  reducerPath: 'main',
  baseQuery: customApiFetchBase,
  tagTypes: [
    'User',
    'Assets',
    'Auth',
    'Balances',
    'Crypto',
    'Transactions',
    'Withdrawals',
    'Fees',
    'Markets',
    'Orders',
    'Quote',
    'taxReport',
    'Trades',
    'Tradingview',
    'CryptoDeposits',
    'CustodyReports',
    'GenerateCustodyReports'
  ],
  endpoints: () => ({})
});
